import React from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { checkIsPdf, invoiceDisplayName, parseInvoiceUrls } from './truckFormConfig';

export default function InvoiceAttachmentList({ value, compact = false, title = 'Invoices' }) {
  const invoices = parseInvoiceUrls(value);
  if (!invoices.length) return null;

  return (
    <Box>
      {!compact && (
        <Typography variant="subtitle2" sx={{ fontWeight: 900, mb: 1, display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <ReceiptIcon fontSize="small" /> {title}
        </Typography>
      )}
      <Stack spacing={1}>
        {invoices.map((invoiceUrl, index) => (
          <Stack
            key={`${invoiceUrl}-${index}`}
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            sx={{ p: compact ? 0 : 1, borderRadius: 2, bgcolor: compact ? 'transparent' : '#f8fbff', border: compact ? 0 : '1px solid #d9e7ef' }}
          >
            <Chip
              icon={<ReceiptIcon />}
              label={`${invoiceDisplayName(invoiceUrl, `Invoice ${index + 1}`)}${checkIsPdf(invoiceUrl) ? ' • PDF' : ''}`}
              sx={{ fontWeight: 800, justifyContent: 'flex-start', maxWidth: '100%' }}
            />
            <Button size="small" variant="outlined" startIcon={<OpenInNewIcon />} href={invoiceUrl} target="_blank" rel="noreferrer" sx={{ fontWeight: 900 }}>
              Open
            </Button>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
